<template>
  <div class="distance-meta">
    <img loading="lazy" src="./location-pin-white.svg" width="15" height="21" />
    <translate :tt="{ distance }"> {distance, distance, short} </translate>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class MiniCardDistance extends Vue {
  @Prop({ required: true })
  distance: { km: number; mi: number }
}

export default toNative(MiniCardDistance)
</script>

<style scoped>
.distance-meta {
  background: var(--colour-orange);
  border-radius: 0 0.3em 0.3em 0;
  color: #111111;
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  left: 0;
  padding: 0.3em 0.5em;
  position: absolute;
  top: -1.9em;
  font-size: var(--body);
  white-space: nowrap;
}

.distance-meta img {
  height: 1.4em;
  margin-right: 0.35em;
}
</style>
